import type {AuthUser} from '../types/domain'
import {createContext} from 'react'

export const AuthContext = createContext<{currentUser: AuthUser | null}>({currentUser: null})
